import Link from 'next/link';
import { useState } from 'react';
import { Container } from './Container.jsx';
import { Logo } from './Logo.jsx';
import { PrimaryNav } from './PrimaryNav.jsx';

const VGLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 234 57"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M106.8 23L120 6H83.8c-6.6 10-12.8 20.3-19.4 29.7l-.2-.2L45.7 6.1H8.9l35.4 44.1h40.4L106.8 23M172 31.7h16.7c0 3.4.6 7.3-.5 10.3a6.7 6.7 0 0 1-4.1 3.3h-25.5c-2-.3-4-2.5-4.5-4.4v-24l.6-2.7a7.3 7.3 0 0 1 3.7-3H183l2 .3c2.5 1 3.6 3.4 3.9 6h29a16 16 0 0 0-1.4-6.7 9.8 9.8 0 0 0-7-4.7h-64.5s-9.6-.6-15.2.9a8.7 8.7 0 0 0-4.8 7.3v22.6c.3 3.2-.9 7 1.3 9.4 2 3 5.2 3.6 8.4 4h70c2.8 0 5.6.3 7.8-.9 3-1.4 5-4.4 5.4-7.7V26.8H172v4.9"
      fill="#FFF"
    />
    <path
      d="M217.8 41.7a10 10 0 0 1-5.4 7.7c-2.2 1.2-5 .8-7.7.8h-70c-3.3-.3-6.6-1-8.5-4-2.2-2.3-1-6.1-1.4-9.3l.1-22.6c.2-3 2-6 4.8-7.3C135.3 5.5 145 6 145 6h64.4c2.7.4 5.8 2.2 7 4.7 1 2 1.4 4.4 1.4 6.7h-29c-.2-2.6-1.3-5-3.9-6l-2-.3h-24.4c-1.4.5-3 1.7-3.7 3l-.6 2.6v24c.5 2 2.5 4.2 4.5 4.5h25.5a6.7 6.7 0 0 0 4-3.3c1.2-3 .6-6.9.6-10.3H172v-4.9h45.9v15M8.8 6h36.8l18.5 29.5.2.2C71 26.4 77.2 16.2 83.8 6.1H120L106.8 23l-22 27.3H44.2L8.9 6.2M0 0v56.7h234V0H0"
      fill="#DD0100"
    />
  </svg>
);

const E24Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin meet"
    viewBox="0 0 200 100"
    width="100%"
    height="100%"
  >
    <path fill="#545454" d="M0 0h70v100H0z" />
    <path fill="#fff" d="M61 9H9v82h52V76H24V57h37V42H24V24h37z" />
    <path fill="#C14232" d="M78 0h122v100H78z" />
    <path fill="#fff" d="M160 32l-20 29h20z" />
    <path
      d="M130.6 48.3l.9-1.6c1.2-2.7 2.1-5.6 2.4-8.6l.1-2.7A26.6 26.6 0 0 0 107.7 9H88v15h18c5.6.7 9.4 4.1 10.3 9.6 1 6.3-1.6 11.5-11.2 22.4l-4.6 5.2A374 374 0 0 0 88 76v15h73V76h-51.7c5.8-7.7 18.4-22.5 21.3-27.7zM175 76h15v15h-15zM175 9h15v52h-15z"
      fill="#fff"
    />
  </svg>
);

export function Header() {
  return (
    <div className="header">
      <Container>
        <nav className="nav">
          <ul className="nav__list">
            <li className="brands">
              <Link href="/">
                <a className="brands__penger">
                  <Logo />
                </a>
              </Link>
              <a
                className="brands__vg brands__partner"
                href="https://www.vg.no/"
              >
                <VGLogo />
              </a>
              <a className="brands__e24 brands__partner" href="https://e24.no/">
                <E24Logo />
              </a>
            </li>
            <li className="nav__desktopNav">
              <ul className="desktopNav">
                <li>
                  <Link href="/boliglan">
                    <a className="desktopNav__link">Boliglån</a>
                  </Link>
                </li>
                <li>
                  <Link href="/forbrukslan">
                    <a className="desktopNav__link">Forbrukslån</a>
                  </Link>
                </li>
              </ul>
            </li>
            <PrimaryNav />
          </ul>
        </nav>
      </Container>
      <style jsx>{`
        .header {
          padding-top: 18px;
          padding-bottom: 18px;
          background-color: var(--bgHotBlue);
        }

        .nav__list {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .brands {
          display: flex;
          align-items: center;
          flex-grow: 1;
        }

        .brands__penger {
          display: block;
          width: 140px;
        }

        .brands__partner {
          filter: grayscale(100%);
        }

        .brands__partner:hover {
          filter: none;
        }

        .brands__vg {
          width: 64px;
          margin-left: 18px;
        }

        .brands__e24 {
          width: 32px;
          margin-left: 9px;
        }

        .brands :global(svg) {
          vertical-align: bottom;
        }

        .nav__desktopNav {
          display: none;
        }

        @media screen and (min-width: 750px) {
          .header {
            padding-top: 24px;
            padding-bottom: 24px;
          }

          .nav__desktopNav {
            display: flex;
            align-items: center;
          }

          .desktopNav {
            margin: 0;
            padding: 0;
            list-style: none;
          }

          .desktopNav li {
            display: inline-block;
          }

          .desktopNav li + li {
            margin-left: 42px;
          }

          .desktopNav__link {
            display: inline-flex;
            align-items: center;
            height: 28px;
            padding: 0 12px;
            color: var(--bgHotBlue__dimText);
            font-weight: 700;
            text-decoration: none;
          }

          .desktopNav__link:hover,
          .desktopNav__link:focus {
            color: var(--bgHotGreen__tintedText);
          }
        }
      `}</style>
    </div>
  );
}
